import { PAYMENT_ENDPOINT } from '@features/Paywall/api/payments';

import { get } from '@/api/api';

export const getIpInfo = async (): Promise<{
  country: string;
  countryCode: string;
  city: string;
}> => {
  try {
    const ipInfoData = await get({
      endpoint: PAYMENT_ENDPOINT,
      path: 'ip_api',
    });

    const country = String(ipInfoData?.country ?? '');
    const countryCode = String(ipInfoData?.countryCode ?? '');
    const city = String(ipInfoData?.city ?? '');

    return { country, countryCode, city };
  } catch (error) {
    console.warn('Failed to fetch IP info', error);
    throw new Error('Failed to fetch IP info', { cause: error });
  }
};
